import { useControlLayerStore } from '@/store-pinia/control-layer';

const imageChangeKeys = [
  // Uploads
  'srcFile',
  // Designs
  'id',
  // Text
  'text',
  'font',
  'effect',
  'effectConfig'
];

export default (changesets = []) => {
  changesets.forEach(changeset => {
    if (
      Object.keys(changeset.changeset).filter(changedKey =>
        imageChangeKeys.includes(changedKey)
      ).length > 0
    ) {
      useControlLayerStore().elementAllowedToResizeByImageDimensions.add(
        changeset.uid
      );
      if (Object.hasOwn(changeset.changeset, 'srcFile')) {
        useControlLayerStore().elementAllowedToResizeByDPI.add(changeset.uid);
      }
    }
  });
};
